import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1.5 text-xs text-foreground-500">
      <Link to="/" className="hover:text-primary-700 cursor-pointer">
        Home
      </Link>
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`} className="inline-flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-400"></i>
          {c.to ? (
            <Link to={c.to} className="hover:text-primary-700 cursor-pointer">
              {c.label}
            </Link>
          ) : (
            <span className="font-semibold text-foreground-800">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}